"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertMessageType = exports.WindowPosition = void 0;
var axios_1 = __importDefault(require("axios"));
var browser_1 = require("@sentry/browser");
var mobx_1 = require("mobx");
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
var WindowPosition;
(function (WindowPosition) {
    WindowPosition[WindowPosition["HIDDEN"] = 0] = "HIDDEN";
    WindowPosition[WindowPosition["CLOSE"] = 1] = "CLOSE";
    WindowPosition[WindowPosition["OPEN"] = 2] = "OPEN";
})(WindowPosition = exports.WindowPosition || (exports.WindowPosition = {}));
var AlertMessageType;
(function (AlertMessageType) {
    AlertMessageType[AlertMessageType["INFO"] = 0] = "INFO";
    AlertMessageType[AlertMessageType["ERROR"] = 1] = "ERROR";
})(AlertMessageType = exports.AlertMessageType || (exports.AlertMessageType = {}));
var SELECT_REQUEST_DELAY = 500;
var HIDE_REQUEST_WINDOW_DELAY = 2000;
var ALERT_MESSAGE_VISIBLE_TIME = 3000;
var MESSAGE_LIST_PAGE_PATH = '/users/estimates/messages/';
var URL_API_ENDPOINTS = {
    UNREAD_REQUESTS: '/api/users/estimates/requests/unread_requests',
    OPEN_MESSAGE: '/api/users/estimates/messages/:id/open',
    ESTIMATE_MESSAGE: '/users/estimates/requests/:request_id/messages.json'
};
var UnreadRequestStore = /** @class */ (function () {
    function UnreadRequestStore() {
        var _this = this;
        this._windowPosition = WindowPosition.HIDDEN;
        this._requestItems = [];
        this._isRequestDetailVisible = false;
        this._isMessageSubmitting = false;
        this.toggleWindow = function () {
            if (_this._windowPosition === WindowPosition.OPEN) {
                _this._windowPosition = WindowPosition.CLOSE;
            }
            else if (_this._windowPosition === WindowPosition.CLOSE) {
                _this._windowPosition = WindowPosition.OPEN;
            }
        };
        this.hideWindow = function () {
            _this._windowPosition = WindowPosition.HIDDEN;
        };
        this.moveToMessageListPage = function () {
            location.href = MESSAGE_LIST_PAGE_PATH;
        };
        this.selectRequest = function (requestId) { return __awaiter(_this, void 0, Promise, function () {
            var item, messages, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._selectedRequest) {
                            return [2 /*return*/];
                        }
                        item = this._requestItems.find(function (item) { return item.request.id === requestId; });
                        if (!item) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        this._selectedRequest = item.request;
                        if (!!item.isOpened) return [3 /*break*/, 3];
                        messages = item.request.messages;
                        return [4 /*yield*/, Promise.all(messages.map(function (_a) {
                                var id = _a.id;
                                return axios_1.default.put(URL_API_ENDPOINTS.OPEN_MESSAGE.replace(':id', String(id)));
                            }))];
                    case 2:
                        _a.sent();
                        messages.forEach(function (_a) {
                            var id = _a.id;
                            return google_analytics_manager_1.default.postGAEvent('message_opened', 'click', String(id));
                        });
                        _a.label = 3;
                    case 3:
                        this._isRequestDetailVisible = true;
                        item.isOpened = true;
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this._selectedRequest = undefined;
                        (0, browser_1.captureException)(error_1);
                        this.alertMessage({
                            type: AlertMessageType.ERROR,
                            message: 'メッセージの開封に失敗しました\n時間をおいて再度お試しください'
                        });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.deselectRequest = function () {
            _this._isRequestDetailVisible = false;
            // メッセージの画面が隠れてから選択を解除したい
            setTimeout(function () { _this._selectedRequest = undefined; }, SELECT_REQUEST_DELAY);
        };
        this.submitMessage = function (requestId, message) { return __awaiter(_this, void 0, Promise, function () {
            var data, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._isMessageSubmitting) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this._isMessageSubmitting = true;
                        data = new FormData();
                        data.append('message_body', message);
                        return [4 /*yield*/, axios_1.default.post(URL_API_ENDPOINTS.ESTIMATE_MESSAGE.replace(':request_id', String(requestId)), data)];
                    case 2:
                        _a.sent();
                        this.alertMessage({ type: AlertMessageType.INFO, message: '送信しました' });
                        setTimeout(function () { return _this.removeRepliedRequestItem(requestId); }, ALERT_MESSAGE_VISIBLE_TIME);
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        (0, browser_1.captureException)(error_2);
                        this.alertMessage({
                            type: AlertMessageType.ERROR,
                            message: '送信に失敗しました。\n時間をおいて再度お試しください。'
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this._isMessageSubmitting = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.fetchUnreadRequestItem = function () { return __awaiter(_this, void 0, Promise, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default
                            .get(URL_API_ENDPOINTS.UNREAD_REQUESTS)];
                    case 1:
                        data = (_a.sent()).data.data;
                        return [2 /*return*/, data ? data.requests.map(function (req) { return ({ request: req, isOpened: false }); }) : []];
                }
            });
        }); };
        this.initializeUnreadRequestItems();
    }
    Object.defineProperty(UnreadRequestStore.prototype, "isWindowOpened", {
        get: function () {
            return this._windowPosition === WindowPosition.OPEN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnreadRequestStore.prototype, "windowPosition", {
        get: function () {
            return this._windowPosition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnreadRequestStore.prototype, "requestItems", {
        get: function () {
            return this._requestItems;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnreadRequestStore.prototype, "selectedRequest", {
        get: function () {
            return this._selectedRequest;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnreadRequestStore.prototype, "isRequestDetailVisible", {
        get: function () {
            return this._isRequestDetailVisible;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnreadRequestStore.prototype, "alertMessageConfig", {
        get: function () {
            return this._alertMessageConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnreadRequestStore.prototype, "isMessageSubmitting", {
        get: function () {
            return this._isMessageSubmitting;
        },
        enumerable: false,
        configurable: true
    });
    UnreadRequestStore.prototype.initializeUnreadRequestItems = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.fetchUnreadRequestItem()];
                    case 1:
                        _a._requestItems = _b.sent();
                        if (this._requestItems.length > 0) {
                            this._windowPosition = WindowPosition.CLOSE;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _b.sent();
                        (0, browser_1.captureException)(error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UnreadRequestStore.prototype.removeRepliedRequestItem = function (requestId) {
        var _this = this;
        this._requestItems = this._requestItems.filter(function (item) { return item.request.id !== requestId; });
        this.deselectRequest();
        if (this._requestItems.length === 0) {
            setTimeout(function () { _this._windowPosition = WindowPosition.HIDDEN; }, HIDE_REQUEST_WINDOW_DELAY);
        }
    };
    UnreadRequestStore.prototype.alertMessage = function (config) {
        var _this = this;
        this._alertMessageConfig = config;
        setTimeout(function () { _this._alertMessageConfig = undefined; }, ALERT_MESSAGE_VISIBLE_TIME);
    };
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], UnreadRequestStore.prototype, "_windowPosition", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object)
    ], UnreadRequestStore.prototype, "_requestItems", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], UnreadRequestStore.prototype, "_isRequestDetailVisible", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], UnreadRequestStore.prototype, "_selectedRequest", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], UnreadRequestStore.prototype, "_alertMessageConfig", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], UnreadRequestStore.prototype, "_isMessageSubmitting", void 0);
    return UnreadRequestStore;
}());
exports.default = UnreadRequestStore;
